import { Component, Input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';
import { DateService } from '../../services/date/date.service';
import { GpsLogDateGroup } from '../../services/gps-logs/gps-log-date-group.model';
import { GpsLog } from '../../services/gps-logs/gps-log.model';
import { GpsLogsResponse } from '../../services/gps-logs/gps-logs-response.model';
import { SearchService } from '../../services/search/search.service';
import { Business } from '../../services/trucks/truck.model';
import { GpsLogItem } from '../../services/gps-logs/gps-log-item.model';

@Component({
    selector: 'app-gps-logs',
    templateUrl: './gps-logs.component.html',
    styleUrls: ['./gps-logs.component.css'],
    providers: [Title]
})
export class GpsLogsComponent {

    @Input() gpsLogDateGroups: GpsLogDateGroup[];
    @Input() gpsLogsResponse: GpsLogsResponse;

    constructor(private configService: ConfigService,
        private dateService: DateService,
        private router: Router,
        private searchService: SearchService,
        private titleService: Title) {
    }

    createRequest(log: GpsLogItem): void {
        const address = this.router.routerState.snapshot.root.queryParams['address'];
        const location = address ? address : this.searchService.latitude + ',' + this.searchService.longitude;

        // noinspection JSIgnoredPromiseFromCall
        this.router.navigate(['create-video-request', log.truckNumber], {
            queryParams: {
                computerType: log.computerType,
                deviceId: log.deviceId,
                ipAddress: log.ipAddress,
                location: location,
                site: this.searchService.site.siteNumber,
                softwareVersion: log.softwareVersion,
                timestamp: this.dateService.momentToClosestMinute(log.timestamp).format(),
                business: Business[log.business],
            }
        });
    }

    businessCaption(business: Business): string {
        return Business[business];
    }

    fromConfig(key: string): string {
        const value = this.configService.config[key] as string;
        return value;
    }

    // getMailToHref(log: GpsLog): string {
    //     const supportEmails = this.configService.config.supportEmails;
    //     return `mailto:${supportEmails}?subject=No Unit for Device ${log.deviceId}...`;
    // }

    viewOnMap(log: GpsLogItem): void {
        const tree = this.router.parseUrl(this.router.url);
        tree.queryParams['display'] = 'map';
        tree.queryParams['truckNumber'] = log.truckNumber;
        tree.queryParams['computerType'] = log.computerType;
        tree.queryParams['deviceId'] = log.deviceId;
        tree.queryParams['ipAddress'] = log.ipAddress;
        tree.queryParams['softwareVersion'] = log.softwareVersion.toString();
        tree.queryParams['timestamp'] = this.dateService.momentToClosestMinute(log.timestamp).format();
        tree.queryParams['selectedDateGroup'] = null;
        tree.queryParams['business'] = Business[log.business];
        this.router.navigateByUrl(tree);
    }
}
